module.exports = __webpack_public_path__ + "static/yellowtail-c4c8df8e5422fcb7a2e2a387d9ecbeef.png";